<template>
    <div id="WaysToUseSuites">
        <div class="top">
            <div class="content">
                <h1>Ways to Use a Texas Rangers Suite at Globe Life Field</h1>
                <p>Looking for unforgettable ways to elevate your next event? A <strong>Texas Rangers suite</strong> at
                    Globe Life Field
                    offers the perfect mix of luxury, exclusivity, and a world-class baseball experience. Whether you're
                    entertaining clients or celebrating a personal milestone, a <strong>Rangers suite</strong> provides
                    a one-of-a-kind
                    setting that leaves a lasting impression.</p>
            </div>
        </div>
        <div class="bottom">
            <div class="container">
                <div class="item">
                    <h2>Popular Uses for a Rangers Suite:</h2>
                    <div class="card">
                        <h3>Corporate & Business Events</h3>
                        <ul>
                            <li>Client Appreciation & Entertainment – Impress your top clients with a VIP experience at
                                a Rangers game.</li>
                            <li>Vendor or Partner Appreciation – Strengthen relationships with key partners in a
                                private, upscale setting.</li>
                            <li>Prospect Entertainment & Business Development – Move business forward by hosting
                                potential clients in a suite.</li>
                            <li>Closing Business Deals – Make negotiations more memorable by combining them with live
                                MLB action.</li>
                            <li>Employee Appreciation & Retention – Reward your team with an unforgettable night out.
                            </li>
                            <li>Company Outings & Office Parties – Perfect for team celebrations, holiday parties, or
                                corporate milestones.</li>
                            <li>Onboarding & Recruiting Events – Impress new hires or attract top talent with a suite
                                experience.</li>
                            <li>Business Meetings with a Twist – Host productive meetings with the excitement of the
                                game in the background.</li>
                            <li>Team-Building Events – Foster stronger collaboration in a relaxed, engaging environment.
                            </li>
                        </ul>
                        <h3>Personal Celebrations</h3>
                        <ul>
                            <li>Birthday Parties – Celebrate your special day in a premium suite with friends and
                                family.</li>
                            <li>Anniversary Celebrations – Mark your milestone with a luxurious game day experience.
                            </li>
                            <li>Family Reunions – Reconnect with loved ones while enjoying America’s pastime.</li>
                            <li>Graduations – Honor a major achievement in a unique and memorable way.</li>
                            <li>Retirement Parties – Send off a colleague or loved one with a celebration they’ll never
                                forget.</li>
                            <li>Networking Events – Impress industry peers and grow your professional network in style.
                            </li>
                        </ul>
                    </div>
                </div>
                <div class="sep"></div>
                <div class="item">
                    <h2>Book Your Rangers Suite Today</h2>
                    <div class="card">
                        <p>Whether it's for corporate hospitality, client entertainment, or a special personal
                            celebration, a suite at Globe Life Field delivers the perfect blend of comfort, privacy, and
                            excitement.<br /><br />Reserve your Texas Rangers suite today and turn your event into an
                            unforgettable experience.
                        </p>
                        <div class="btns">
                            <a :style="{background: '#2D984B'}"
                                href="https://flex2.seasonshare.com/texasrangers_suites/purchase_seats?purchaseSeatTab=find_games"
                                target="_blank">Explore What’s Available Now</a>

                            <router-link :to="{ path: '/', hash: '#BookSuite'}" >contact
                                us</router-link>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>

export default {
    name: "WaysToUseSuites",
    components: {},
    data() {
        return {

        };
    },
    methods: {

    },
};
</script>

<style lang="scss" scoped>
#WaysToUseSuites {
    display: flex;
    flex-direction: column;
    width: 100%;

    .top {
        background-image: url("~@/assets/images/backgrounds/bg_ways-to-use.jpg");
        background-size: cover;
        background-repeat: no-repeat;
        height: 1067px;
        display: flex;
        justify-content: center;
        align-items: center;

        .content {
            width: 90%;
            max-width: 504px;

            h1 {
                color: var(--STH-White, #FFF);
                text-align: center;
                font-family: "BertholdCondensed";
                font-size: 40px;
                font-style: normal;
                font-weight: 700;
                line-height: 38px;
                /* 95% */
                text-transform: uppercase;
                margin-bottom: 30px;
                padding-bottom: 16px;
                position: relative;

                &::after {
                    content: "";
                    position: absolute;
                    pointer-events: none;
                    bottom: 0;
                    left: 50%;
                    transform: translateX(-50%);
                    height: 2px;
                    width: 60px;
                    background: var(--STH-White, #FFF);
                }
            }

            p {
                color: var(--STH-White, #FFF);
                text-align: center;
                font-family: Gotham;
                font-size: 16px;
                font-style: normal;
                font-weight: normal;
                line-height: 24px;
                /* 150% */

                strong {
                    color: #259EF3;
                    font-family: Gotham;
                    font-size: 16px;
                    font-style: normal;
                    font-weight: 700;
                    line-height: 24px;
                }
            }
        }
    }

    .bottom {
        padding: 120px 0;
        background: linear-gradient(90deg, #FAF9FA 0%, #EEE 100%);

        .container {
            display: flex;
            flex-direction: column;
            gap: 60px;

            .item {
                display: flex;
                flex-direction: column;
                gap: 40px;

                h2 {
                    color: var(--STH-Black, #000);
                    font-family: "BertholdCondensed";
                    font-size: 40px;
                    font-style: normal;
                    font-weight: 700;
                    line-height: 38px;
                    /* 95% */
                    text-transform: uppercase;
                    padding-bottom: 16px;
                    position: relative;
                    text-align: left;
                    max-width: 382px;

                    &::after {
                        content: "";
                        pointer-events: none;
                        position: absolute;
                        bottom: 0;
                        left: 0;
                        width: 66px;
                        height: 2px;
                        background: #DBDCDD;
                    }

                    &::before {
                        content: "";
                        pointer-events: none;
                        position: absolute;
                        bottom: 0;
                        left: 0;
                        width: 6px;
                        height: 2px;
                        background: #000;
                        z-index: 1;
                    }
                }

                .card {
                    background: var(--STH-White, #FFF);
                    box-shadow: 0 0 15px 0 rgba(0, 0, 0, 0.10);
                    padding: 60px;

                    @media screen and (max-width: 1000px) {
                            padding: 25px;
                        }

                    h3 {
                        color: #002D72;
                        font-family: Gotham;
                        font-size: 18px;
                        font-style: normal;
                        font-weight: 700;
                        line-height: 24px;
                        /* 133.333% */
                        text-transform: uppercase;
                        text-align: left;
                        margin-bottom: 24px;
                    }

                    ul {
                        margin-left: -0px;

                        &:first-of-type {
                            margin-bottom: 40px;
                        }

                        li {
                            color: var(--STH-Black, #000);
                            font-family: Gotham;
                            font-size: 18px;
                            font-style: normal;
                            font-weight: normal;
                            line-height: 24px;
                            text-align: left;
                        }
                    }

                    p {
                        color: var(--STH-Black, #000);
                        font-family: Gotham;
                        font-size: 18px;
                        font-style: normal;
                        font-weight: normal;
                        line-height: 24px;
                        /* 133.333% */
                        text-align: left;
                    }

                    .btns {
                        display: flex;
                        flex-direction: row;
                        gap: 40px;
                        margin-top: 40px;

                        @media screen and (max-width: 1000px) {
                            flex-direction: column;
                        }


                        a {
                            color: var(--STH-White, #FFF);
                            font-family: Gotham;
                            font-size: 16px;
                            font-style: normal;
                            font-weight: 700;
                            line-height: normal;
                            letter-spacing: 0.32px;
                            text-transform: uppercase;
                            padding: 22px 36px;
                            text-align: center;
                            width: 100%;
                            border-radius: 10px;
                            background: #51D074;
                            padding: 22px 36px;
                        }

                    }
                }
            }

            .sep {
                width: 100%;
                height: 1px;
                background-color: rgba($color: #000000, $alpha: 0.2);
            }
        }
    }
}
</style>
